import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.aiAlerts`;
export const SET_SELECTED_AI_ALERT = `${SCOPE}/SET_SELECTED_AI_ALERT`;
export const SET_ALL_EXCEPT_ANOMALY_PAYLOAD = `${SCOPE}/SET_ALL_EXCEPT_ANOMALY_PAYLOAD`;
export const RESET_ALERT_STATE = `${SCOPE}/RESET_ALERT_STATE`;
